import { useProvideInjectWrapper } from '@/utils/useProvideInject';

export const usePopupContainer = () => {
	const { injectValue } = useProvideInjectWrapper;
	const wrapper = injectValue(document.body);
	const getPopupContainer = () => {
		return wrapper.value;
	};
	return { getPopupContainer };
}
